import React, { useRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';

interface SignaturePadProps {
  onSave: (signature: string) => void;
  width?: number;
  height?: number;
}

const SignaturePad: React.FC<SignaturePadProps> = ({ 
  onSave, 
  width = 500, 
  height = 200 
}) => {
  const signaturePad = useRef<SignatureCanvas>(null);

  const handleClear = () => {
    signaturePad.current?.clear();
  };

  const handleSave = () => {
    if (signaturePad.current?.isEmpty()) {
      alert('Please provide a signature');
      return;
    }
    
    // Get the signature as PNG with white background
    const canvas = signaturePad.current?.getCanvas();
    const context = canvas.getContext('2d');
    
    // Save current canvas state
    context.save();
    
    // Store the current composite operation
    const compositeOperation = context.globalCompositeOperation;
    
    // Set white background
    context.globalCompositeOperation = 'destination-over';
    context.fillStyle = '#fff';
    context.fillRect(0, 0, canvas.width, canvas.height);
    
    // Get the image data with white background
    const signatureData = canvas.toDataURL('image/png');
    
    // Restore canvas state
    context.globalCompositeOperation = compositeOperation;
    context.restore();
    
    onSave(signatureData);
  };

  return (
    <div className="space-y-4">
      <div className="border rounded-lg overflow-hidden">
        <SignatureCanvas
          ref={signaturePad}
          canvasProps={{
            width,
            height,
            className: 'signature-canvas bg-white',
          }}
        />
      </div>
      <div className="flex space-x-4">
        <button
          onClick={handleClear}
          className="px-4 py-2 text-gray-600 border rounded hover:bg-gray-50"
        >
          Clear
        </button>
        <button
          onClick={handleSave}
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
        >
          Save Signature
        </button>
      </div>
    </div>
  );
};

export default SignaturePad;